(function(){
    'use strict'

    angular
    .module('app.usuarios')
    .controller('EditarUsuario', EditarUsuario);

    EditarUsuario.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams', 'UsuariosService', 'GruposService', 'logger', '$location', 'UserInfoService', 'ApiBaseService'];

    function EditarUsuario($q, $scope, $animationsSrv, $routeParams, UsuariosService, GruposService, logger, $location, UserInfoService, ApiBaseService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.usuarioId = $routeParams.id ? $routeParams.id : 0;
        
        vm.grupos = [];
        vm.clientes = [];
        vm.empresasFumigadoras = [];

        vm.usuario = {
            grupoId: -1,
            clienteSistemaId: 0,
            empresaFumigadoraId: 0
        };

        const companiaId = UserInfoService.getCompaniaId();

        var promiseGrupo = getGrupos();
        const promiseClientes = getComboData(vm.clientes, 'api/Clientes', [companiaId], 'Error al obtener los clientes.');
        const promiseEmpresasFumigadoras = getComboData(vm.empresasFumigadoras, 'api/Empresas-Fumigadoras', [companiaId], 'Error al obtener las empresas fumigadoras.');

        if(vm.usuarioId){
            getById();
        }

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        function getGrupos(){
            var promise = GruposService.getAll(UserInfoService.getCliente())
            .then(function(grupos){
                vm.grupos = grupos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los grupos')
            }); 
            
            return promise;
        }

        function getById(){

            $q.all([promiseGrupo, promiseClientes, promiseEmpresasFumigadoras])
            .then(function(){
                UsuariosService.getById(UserInfoService.getCliente(), vm.usuarioId)
                .then(function(usuario){
                    vm.usuario = usuario;
                })
                .catch(function(error){
                    $logger.error('Error al obtener los datos del usuario')
                }); 
            });
        }

        vm.save = function(){

            $scope.submitted = true;

            if(vm.usuario.grupoId == -1){
                $scope.usuarioForm.usergrupo.$setValidity("different", false);
            }

            if($scope.usuarioForm.$valid){
                if(!vm.usuario.id){
                    vm.usuario.id = 0;
                    saveUser();
                }
                else{
                    if($scope.usuarioForm.$dirty){
                        updateUser();
                    }
                    else{
                        logger.info('No has modificado ningún dato');
                    }
                }
                
            }
            else{
                logger.error('Por favor corrija los datos');
            }
        
        };

        vm.gruposChange = function(){
            if(vm.usuario.grupoId == -1){
                $scope.usuarioForm.usergrupo.$setValidity("different", false);
            }
            else{
                $scope.usuarioForm.usergrupo.$setValidity("different", true);
            }
        }

        function saveUser() {
            var promise = UsuariosService.save(vm.usuario);
                
            promise
            .then(function(response){
                logger.success('Usuario creado con éxito.');
                clearUserData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                    logger.error(`Hubo un erro al crea el usuario: ${error.data.Message}`);
                        break;
                
                    default:
                        logger.error('Hubo un erro al crea el usuario');
                        break;
                }
            }); 
        }

        function updateUser() {
            var promise = UsuariosService.update(vm.usuario);
                
            promise
            .then(function(response){
                logger.success('Usuario modificado con éxito.');
                $location.path('/usuarios');
            })
            .catch(function(error){
                logger.error('Hubo un erro al modificar el usuario');
            }); 
        }

        function clearUserData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.usuario = {
                grupoId: -1,
                clienteSistemaId: 0,
                empresaFumigadoraId: 0
            };
            // Set back to pristine.
            $scope.usuarioForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.usuarioForm.$setUntouched();
        }

    }
})();